module.exports = __webpack_public_path__ + "static/hero@2x-015591ed80d82f7e8bb3db8fbf954f49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/consultancies/hero@2x.jpg
// module id = 2543
// module chunks = 56719701542624